import {backButton, init, mainButton, secondaryButton, settingsButton, viewport} from "@telegram-apps/sdk"

export default defineNuxtPlugin(() => {
    onNuxtReady(async () => {
        init()
        backButton.mount.ifAvailable()
        backButton.hide.ifAvailable()
        viewport.mount.ifAvailable()
        mainButton.mount.ifAvailable()
        secondaryButton.mount.ifAvailable()

        // if(settingsButton.mount.ifAvailable()) {
        //     settingsButton.onClick(() => useState('showSettings').value = true)
        //     settingsButton.show.ifAvailable()
        // }

        getAuthToken()
    })
})